import { isNotEmpty } from '../isEmpty'
import { getInitialism } from '../names'

export const getActionTileLabel = ({ short, name }: { name: string; short?: string }): string => {
  if (isNotEmpty(short)) return short
  if (name.length >= 5) return getInitialism(name)
  return name
}
